import axios from '@/libs/api.request';

export const getUnitList = data => {
    return axios.request({
        url: 'api/systemManagement/unitManagement/getUnitList',
        data: data,
        method: 'post'
    });
};
